/* eslint-disable */
import { FormRecordFieldView, FormRecordFieldViewFactory, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import { FormRecordPaymentTypeFieldComponent } from '../../admin/form/form-record/fields/payment-type/form-record-payment-type-field.component';
/* eslint-enable */

export class FormRecordPaymentTypeFieldViewFactory implements FormRecordFieldViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createView(): ComponentRef<FormRecordFieldView> {
    const cmp = this.cfr.resolveComponentFactory(FormRecordPaymentTypeFieldComponent)
      .create(this.injector);
    return cmp;
  }

}
